module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAElBMVEXIEC7////Kysrutb/KFzTCABhtLxxJAAAA6klEQVR42u3aWwkCUBQAwYsNNIHPAtpATCDYv4qgCfbLA84k2AC7jiOt/RpoI0vWl6xCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQVsn5qs86Pge7r8hrouU63ga7rsB1oJ0vWl6xCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQVsgpZhaxCViGrkFXIKmQVsgpZhaxCViGrkFXIKmT91G7q7Tb0DRx6Ug79TmXJ+pBVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWsQlYhq5BVyCpkFbIKWYWs4n+yjiO9Ad3Sr3u5zNMHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/39.png
// module id = N2GC
// module chunks = 1